import { isNonNullish, pick } from '@epicuro-next/utilities';
import { Account, Address } from 'graphql-api/gql-api-interfaces';

type AccountProperty = keyof Account;
type AddressProperty = keyof Address;

export const ACCOUNT_SEARCH_PROPS: AccountProperty[] = ['externalId', 'name'];

export const ADDRESS_SEARCH_PROPS: AddressProperty[] = [
  'name',
  'city',
  'street',
];

export function getFilteredAccounts(accounts: Account[], search: string) {
  const searchLowerCaseValue = search.toLowerCase();

  return accounts.filter((account) => {
    const searchAccountFields = getPropertiesValues(
      account,
      ACCOUNT_SEARCH_PROPS,
    );

    if (searchAccountFields.some((v) => v.includes(searchLowerCaseValue))) {
      return true;
    }

    return account.shipToAddresses.some((address) => {
      const searchAddressFields = getPropertiesValues(
        address,
        ADDRESS_SEARCH_PROPS,
      );

      return searchAddressFields.some((v) => v.includes(searchLowerCaseValue));
    });
  });
}

function getPropertiesValues(object: object, props: string[]) {
  return Object.values(pick(object, props))
    .filter(isNonNullish)
    .map((v: string) => v.toLowerCase());
}
